import React, { useEffect, useState } from 'react';
import {
  TextField,
  InputAdornment,
  IconButton,
  CircularProgress
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { APIData } from '../../constants/APIAdresses';

const TagInputField = ({ fileItem, onTagAdded, onFail }) => {
  const [tagInput, setTagInput] = useState('');
  const [loading, setLoading] = useState(false);
  const txtInputRef = React.useRef(null);
  const handleAddTag = async () => {
    if (fileItem != null) {

      if (!tagInput.trim()) return;

      setLoading(true);

      try {
        const res = await fetch(`${APIData.MEDIA}/file/${fileItem.id}/tags`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tags: tagInput.trim() }),
          credentials: 'include' // include cookies for session management
        });

        if (res.ok) {
          onTagAdded?.(tagInput.trim());
          setTagInput('');

        } else {
          onFail?.(tagInput.trim());
          console.error('Failed to add tag', await res.text());
        }
      } catch (err) {
        console.error('Error adding tag', err);
      } finally {
        setLoading(false);

        // Delay focus so the input is re-rendered & enabled
        requestAnimationFrame(() => {
          txtInputRef.current?.focus();
        })
      }
    } else {
      // Probably local usage
      setTagInput('');
      onTagAdded?.(tagInput.trim());
    }
  };
  useEffect(() => {
    // Focus the input when it mounts
    txtInputRef.current?.focus();
  }, [txtInputRef])
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };

  return (
    <TextField
      id={`tag-input-${fileItem?.id}`}
      label="Tag hinzufügen"
      fullWidth
      size="small"
      value={tagInput}
      inputRef={txtInputRef}
      onChange={(e) => setTagInput(e.target.value)}
      onKeyDown={handleKeyDown}
      slotProps={{
        input: {
          readOnly: loading,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={handleAddTag}
                disabled={loading}
              >
                {loading ? <CircularProgress size={18} /> : <SendIcon />}
              </IconButton>
            </InputAdornment>
          )
        }
      }}
    />
  );
};

export default TagInputField;
